import { render, staticRenderFns } from "./sender.vue?vue&type=template&id=73e3c0c5&"
import script from "./sender.vue?vue&type=script&lang=js&"
export * from "./sender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports